import { render, staticRenderFns } from "./FormItems.vue?vue&type=template&id=aa99cdf0&"
import script from "./FormItems.vue?vue&type=script&lang=js&"
export * from "./FormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports